




















































































import Vue from "vue";
import { Component,  Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { GrantData } from "@/entities";
import { Utilities as utils } from "@/shared/utilities";
import WorkflowButtons from '@/components/common/ProgressBar/WorkflowButtons.vue';
import ProgressBar from '@/components/common/ProgressBar/ProgressBar.vue';
import ValidationMessageComponent from '@/components/common/ValidationMessage/ValidationMessage.vue';
import NavButtons from '@/components/common/Buttons/NavButtons.vue';
import { AppConstants as _app } from '@/shared/app.constants';
import { TechnicalReportData } from "@/entities";
import PermissionService from '@/services/permission.service';
import { Locales } from "@/i18n/locales";

const namespace: string = "technicalReport";
const permissionService = new PermissionService();

@Component({
    components: {
        WorkflowButtons,
        ValidationMessageComponent,
        NavButtons,
        ProgressBar
    }
})
export default class TechnicalReportSummary extends Vue {

    @State(namespace) technicalReport!: TechnicalReportData;
    @Action("saveTechnicalReport", { namespace }) saveReport: any;
    @Action("saveTechnicalReportData", { namespace }) saveReportData: any;
    @Prop() technicalReportSections: any;
    @Prop() schema: any;
    @Prop() isDirty: any;
    @Prop() enableButton: any;
    @Prop() preValidation: any;
    @Prop() initiativeId: any;
    @Prop() permitted: boolean;
    actions = _app.actions;
    subjects = _app.subjects;
    actionEnable = [_app.techReportStatus.pendingReview, _app.techReportStatus.readyForValidation];
    // permitted = false;
    defaultLocale: string = localStorage.getItem("language") || Locales.EN;

    formatCurrency(val, currency) {
        return utils.formatCurrency(val, currency, this.defaultLocale);
    }

    /** show validations */
    showValidation(msgs: any) {
        this.technicalReport.validationMessages = msgs;
        this.technicalReport.showValidationDilog = true;
    }

    validationMessageClicked() {
        this.technicalReport.showValidationDilog = false;
        this.technicalReport.validationMessages = [];
    }

    validationMessageClosed() {
        this.technicalReport.showValidationDilog = false;
        this.technicalReport.validationMessages = [];
        (this.$refs.workflowButtonRef as InstanceType<typeof WorkflowButtons>).enableAllButtons();
    }

    // ppoHasPermission(initiativeId: any) {
    //     // Get logged in user initiatives
    //     permissionService.ppoHasPermission(initiativeId).then((hasPermission: boolean) => {
    //         this.permitted = hasPermission;
    //     });
    // }

    /** computed property workflow items */
    get workFlowItems() {
        return this.technicalReport.selectedReport.WorkflowInfo || {}
    }

    // @Watch("initiativeId")
    // ppoPermission(val: any) {
    //     if (val) {
    //         this.ppoHasPermission(val);
    //     } else {
    //         this.permitted = false;
    //     }
    // }

    /** pre validation action */
    // preValidation() {
    //     return this.saveReportData({
    //         data: { data: this.technicalReport.grantData, impactReport: this.technicalReport.impact },
    //         id: this.technicalReport.selectedReport.GrantId,
    //         context: 'submit'
    //     });
    // }

    /** update status on workflow btn click */
    // updateStatus(item) {
    //     const self = this;
    //     this.technicalReport.selectedReport.WorkFlowStatusId = item.StepId;
    //     this.technicalReport.selectedReport.Comments = item.Comments;
    //     this.saveReport({
    //         data: this.technicalReport.selectedReport,
    //         id: this.technicalReport.selectedReport.TechnicalReportId
    //     }).then(resp => {
    //         if(resp) {
    //             this.$router.push({
    //                 name: "grantSummary",
    //                 params: { grantId: this.technicalReport.selectedReport.GrantId.toString() }
    //             });        
    //         }
    //     });
    // }    
    
}
